import { addDoc, deleteDoc } from "firebase/firestore";
import {
  getCollectionRef,
  onCollectionSnapshot,
  getDocumentRef,
  toDocumentData,
  updateDocument,
  fromDocumentData,
} from "./FirebaseRepository";
import AdvanceModel from "../models/AdvanceModel";

class AdvanceRepository {
  private path = (contractUid: string) => `cfContract/${contractUid}/advances`;

  public async addAdvanceToDataBase(data: AdvanceModel): Promise<string> {
    const collection = getCollectionRef(
      this.path(data.contractUid),
      converter(data.contractUid)
    );
    const doc = await addDoc(collection, data);
    return doc.id;
  }

  public deleteAdvanceFromDataBase(contractUid: string, uid: string) {
    const doc = getDocumentRef(this.path(contractUid), uid);
    return deleteDoc(doc);
  }

  public updateAdvanceOnDataBase(
    contractUid: string,
    uid: string,
    updatedData: Partial<AdvanceModel>,
    transaction?: any
  ) {
    const doc = getDocumentRef(this.path(contractUid), uid);
    const data = converter(contractUid).toFirestore(updatedData);
    return updateDocument(doc, data, transaction);
  }

  addAdvancesCollectionSnapshot(
    contractUid: string,
    onCreate: (data: AdvanceModel[]) => void,
    onChange: (data: AdvanceModel[]) => void,
    onRemove: (data: AdvanceModel[]) => void
  ) {
    const collection = getCollectionRef(
      this.path(contractUid),
      converter(contractUid)
    );
    return onCollectionSnapshot(
      collection,
      onCreate,
      onChange,
      onRemove,
      (error) => console.error("AdvanceSnapshot", error)
    );
  }
}

// Firestore data converter
const converter = (contractUid) => ({
  toFirestore: (advance: any) => {
    const data = advance instanceof AdvanceModel ? advance.toSave() : advance;
    return toDocumentData(data);
  },
  fromFirestore: (snapshot, options) => {
    let data = snapshot.data(options);
    data = fromDocumentData(data);
    return AdvanceModel.create(snapshot.id, { ...data, contractUid });
  },
});

export default new AdvanceRepository();
